// Copy right - © 2024 tecera gmbh


export function get_scrollbar_width() {
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);

    const inner = document.createElement("div");
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}

  // utility function to find the main meter of a compound incase we need location or smth similiar
  export  function find_main_meter(compound_water_meter) {
    let main_meter = compound_water_meter.watermeterconfigs.find(meter => meter.compound_role==="main" || meter.compound_role==="single");
    return main_meter;
}


// Presses Button when element is focused and enter gets pressed
export function enter_to_click(node,button) {
  function handleKeyup(event) {
      event.preventDefault();
      if (event.keyCode === 13) {
          button.click();
      }
  }

  node.addEventListener("keyup", handleKeyup);

  return {
      destroy() {
          node.removeEventListener("keyup", handleKeyup);
      }
  };
}